import React from 'react'
import { STATICS } from 'statics'
import { formatCurrenctyWithoutSignal } from 'utils'
import './style.scss'

export function SuccessInfo({ cart = [] }) {
  function getHiredProductsString() {
    const hasOnlyOneProduct = cart.length === 1

    if (hasOnlyOneProduct) return cart[0].name

    const formattedString = cart.reduce((acc, currentValue, index) => {
      const lastItem = index === cart.length - 1
      const firstItem = index === 0
      const { name } = currentValue

      if (firstItem) return name
      if (lastItem) return `${acc} e ${name}`

      return `${acc}, ${name}`
    }, '')

    return formattedString
  }

  function getTotalValue() {
    const totalValue = cart.reduce((accumulator, { value }) => accumulator + value, 0)

    return formatCurrenctyWithoutSignal(totalValue)
  }

  function renderHiredProducts() {
    const formattedString = getHiredProductsString()

    return <span className='description'>{formattedString}</span>
  }

  return (
    <div id='container-products-info'>
      <div className='container-hired'>
        <STATICS.CART />
        <div className='container-info'>
          <span className='title'>O que foi assinado:</span>
          {renderHiredProducts()}
        </div>
      </div>
      <div className='separator' />
      <div className='container-hired'>
        <STATICS.RECEIPT_LONG />
        <div className='container-info'>
          <span className='title'>Valor total:</span>
          <span className='description'>R${getTotalValue()}/mês*</span>
          <span className='observation'>
            *O valor total <strong>será incluído na sua próxima fatura.</strong>
          </span>
        </div>
      </div>
      <div className='separator' />
    </div>
  )
}
